import { SSpecificationDto } from "@/__generated__/graphql";
import CloseCircleBoldIcon from "@/app/_components/Icons/CloseCircleBoldIcon";
import TickCircleBoldIcon from "@/app/_components/Icons/TickCircleBoldIcon";
import RefererChart from "@/app/admin/_components/dashboard/RefererChart";
import { Box, Card, Divider, Icon, Stack, Typography } from "@mui/material";
import { forwardRef, memo } from "react";

const ProductMidSectionSpecifications = forwardRef(({ specifications }: { specifications: SSpecificationDto[] }, ref) => {
  return (
    <Box ref={ref}>
      <Card elevation={0} style={{ background: "transparent", paddingBottom: "1rem" }}>
        <Stack spacing={2} direction="row" alignItems="center">
          <Typography variant="subtitle2" component="section">
            مشخصات
          </Typography>
          <Divider sx={{ width: "100%" }} />
        </Stack>
        <Stack spacing={0.2} width="100%">
          {specifications.map((s, index) => {
            const odd = index % 2;
            return (
              <Card
                key={index}
                elevation={0}
                sx={{
                  p: 0.5,
                  py: 1,
                  borderRadius: 3,
                  ...(odd && { backgroundColor: "grey.50" }),
                  ...(!odd && { backgroundColor: "transparent" }),
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: { md: "start", xs: "space-between" },
                  flexWrap: "wrap",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    minWidth: {
                      xs: "auto",
                      md: "30%",
                    },
                  }}
                  color={"grey.800"}
                >
                  {s.title}
                </Typography>
                <Box sx={{ minWidth: { xs: 240, sm: 450, md: "unset" } }}>
                  {s.type === "Boolean" && (
                    <>
                      {s.checked ? (
                        <Icon color="success">
                          <TickCircleBoldIcon />
                        </Icon>
                      ) : (
                        <Icon color="error">
                          <CloseCircleBoldIcon />
                        </Icon>
                      )}
                    </>
                  )}
                  {s.type === "Text" && (
                    <Typography variant="body1" sx={{ maxWidth: { xs: 240, sm: 450, md: "unset" } }} color={"grey.900"}>
                      {s.text}
                    </Typography>
                  )}
                </Box>
              </Card>
            );
          })}
        </Stack>
      </Card>
    </Box>
  );
});

export default memo(ProductMidSectionSpecifications);
